import { useLocation } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useDriverJs } from '../ui'

/**
 * Component that provides the OrderDetailsModal based on URL search params
 * This allows the parent route to remain visible while showing the order details
 */
export function useStartOnboardingTutorial() {
  const driverJsContext = useDriverJs()
  const { search } = useLocation()
  const searchParams = new URLSearchParams(search)
  const onboarding = searchParams.get('onboarding') || undefined

  useEffect(() => {
    if (driverJsContext && onboarding && typeof driverJsContext.startTutorial === 'function' && !driverJsContext.isActive) {
      driverJsContext.startTutorial()
    }
  // eslint-disable-next-line react/exhaustive-deps
  }, [onboarding])

  return null
}
